import type { PlanReadOnlyKind } from "@/components/freemium/PlanReadOnlyDialog";
import { proUpgradeVariantFromErrorCode } from "@/lib/plan-limit-ui";

export { proUpgradeVariantFromErrorCode };

export function planReadOnlyKindFromErrorCode(
  code: string | undefined,
): PlanReadOnlyKind | null {
  if (code === "PLAN_READ_ONLY") return "note";
  return null;
}

export function isPlanAccessErrorCode(code: string | undefined): boolean {
  return (
    planReadOnlyKindFromErrorCode(code) != null ||
    proUpgradeVariantFromErrorCode(code) != null
  );
}
